import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-882dd1cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "fa check-icon fa-check-square" }
const _hoisted_7 = {
  class: "fa check-icon fa-square-o",
  style: {"color":"#ccc"}
}
const _hoisted_8 = { class: "text-rt btm-tip" }

import draggable from 'vuedraggable'
import { ref, computed, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: ['list', 'width', 'max', 'filter', 'tag'],
  emits: ['update:list', 'change'],
  setup(__props, { emit }) {

const props = __props
const stationCode = useSite2Station()



const data = reactive({
  show: false
})

const value = computed({
  get: () => props.list,
  set: (v) => emit('update:list', v)
})

const drag = ref(false)
const dragOptions = {
  animation: 200,
  disabled: false,
  ghostClass: 'ghost'
}

const tstn = ref('')
const toggle = (v: any) => {
  const reverse = !v.check
  if (reverse) {
    const len = value.value.filter((val: any) => val.check).length
    if (len >= props.max) {
      return ElMessage.error(t('不可展示多于X个选项').replace('X', props.max))
    }
  }
  // tstn.value = 'tstn'
  // if (reverse) {
  //   value.value = [v, ...value.value.filter((val: any) => val !== v)]
  // } else {
  //   value.value = [...value.value.filter((val: any) => val !== v), v]
  // }
  v.check = reverse
  // setTimeout(() => {
  //   tstn.value = ''
  // }, 300)
  emit('change')
}

onMounted(() => {
  // 默认选中前8个
  value.value = value.value.map((item: any, index: number) => {
    return {
      ...item,
      check: index <= 7
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    visible: _unref(data).show,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(data).show) = $event)),
    width: __props.width,
    placement: "bottom-end",
    "hide-after": 0
  }, {
    reference: _withCtx(() => [
      _createElementVNode("span", {
        class: "btn",
        style: {"padding-right":"15px","transform":"translateX(15px)"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(data).show = !_unref(data).show))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default"),
        (__props.list?.length)
          ? (_openBlock(), _createBlock(_unref(draggable), _mergeProps({
              key: 0,
              class: "list-group",
              tag: "transition-group",
              "component-data": {
          tag: 'div',
          type: 'transition-group',
          name: !drag.value ? 'flip-list' : null,
        },
              modelValue: _unref(value),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
            }, dragOptions, {
              onStart: _cache[2] || (_cache[2] = ($event: any) => (drag.value = true)),
              onEnd: _cache[3] || (_cache[3] = ($event: any) => (drag.value = false)),
              handle: ".handle",
              "item-key": "label"
            }), {
              item: _withCtx(({
            element: v,
            element: { cateNameEn, cateNameJp, cateNameZh, cateNameKr, check },
          }) => [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["list-item flex", tstn.value])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["handle", { disabled: !check }])
                  }, _hoisted_4, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn flex-bwn fx-1", { check }]),
                    onClick: ($event: any) => (toggle(v))
                  }, [
                    _createElementVNode("span", null, _toDisplayString({
                    JapanStation: cateNameJp,
                    KoreaStation: cateNameKr,
                    UkStation: cateNameEn,
                  }[_unref(stationCode)]
                    ? {
                        JapanStation: cateNameJp,
                        KoreaStation: cateNameKr,
                        UkStation: cateNameEn,
                      }[_unref(stationCode)]
                    : cateNameZh), 1),
                    _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                      [_vShow, check]
                    ]),
                    _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                      [_vShow, !check]
                    ])
                  ], 10, _hoisted_5)
                ], 2), [
                  [_vShow, __props.filter ? __props.filter(v) : true]
                ])
              ]),
              _: 1
            }, 16, ["component-data", "modelValue"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              "image-size": 100
            })),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('最多可选择X个').replace('X', props.max)), 1)
      ])
    ]),
    _: 3
  }, 8, ["visible", "width"]))
}
}

})